'use strict';

/**
 * Module front agent/déclarant — helpers DOM COMMUNS du simulateur, dédupliqués entre `simulation.js`
 * (web) et `simulation_borne.js` (borne) où ils étaient BYTE-IDENTIQUES. Déplacés VERBATIM.
 *
 * DOM-bound : `$` est fourni globalement par Webpack (autoProvidejQuery). Non testable unitairement
 * (jQuery + select2 + timers) → vérifié au **build** + **recette**. Seule adaptation : `updateCommune`
 * reçoit `lotissementsCities` en paramètre au lieu de lire la constante de closure `LOTISSEMENTS_CITIES`
 * (identique dans les deux fichiers), pour rester une fonction sans état partagé.
 */

function toggleBlockWithCondition(type, condition) {
    $(`.d-condition[data-type='${type}']`).hide();
    $(`.d-condition[data-type='${type}'][data-value='${condition}']`).show();
}

function updateCommune(text, changeData, lotissementsCities) {
    setTimeout(function() {
        if (!!changeData) {
            let newHTML = '<option label="empty"></option>';
            lotissementsCities.forEach((el) => {
                newHTML += `<option value="${el.value}">${el.text}</option>`;
            })
            $("select[name='city']").html(newHTML);

        }

        $("select[name='simulation[town]']").select2({
            placeholder: text
        });
    }, 0)

}

function handleNumberOfPeople(id) {
    var noAdult = parseInt($("#simulation_numberOfAdult").val());
    var noChildren = parseInt($("#simulation_numberOfChild").val());
    var both = noAdult + noChildren;
    var maximumPeople = ((both || noAdult || noChildren) >= 10) && (id !== "AAHI");
    var minimumPeople = (noAdult === 0 &&  noChildren ===0 ) || (both === 0);
    maximumPeople || minimumPeople ? toggleBlockWithCondition('number-people', 4) : toggleBlockWithCondition('number-people', '');
}

function setNameInputForm(formValidateSelect) {
    var formValidate = $(formValidateSelect);
    var inputForm = formValidate.find('input[type="email"], input[type="text"], input[type="number"], input[type="password"]');
    if(formValidate) {
        inputForm.each(function() {
            var _this = $(this);
            var getIdInput = _this.attr('id');
            _this.attr('name', getIdInput);
        });
    }
}

module.exports = {
    toggleBlockWithCondition: toggleBlockWithCondition,
    updateCommune: updateCommune,
    handleNumberOfPeople: handleNumberOfPeople,
    setNameInputForm: setNameInputForm
};
